/**
 * Builds the /login/verify URL the magic-link form navigates to after
 * signInWithOtp succeeds (#798).
 *
 * The `intent` param drives the verify page's explanation copy: `signup`
 * routes say "the link finishes creating your account (or signs you in)",
 * `login` routes say the inverse. It used to be hardcoded to `login`, so
 * /signup submissions got sign-in copy. Neither variant reveals whether the
 * account already exists — that stays enumeration-safe (see
 * docs/modules/auth-roles.md, #741).
 */
export function buildVerifyUrl(args: {
  email: string
  isSignup: boolean
  isHostLogin: boolean
  redirectParam: string | null
  /** #1306 — same-origin return path, already validated by safeNextPath. */
  next?: string | null
}): string {
  const params = new URLSearchParams({
    email: args.email.trim(),
    intent: args.isSignup ? 'signup' : 'login',
  })
  // Host signups funnel into the facilitator flow after auth.
  const redirect =
    args.isHostLogin && !args.redirectParam ? 'host-signup' : args.redirectParam
  if (redirect) params.set('redirect', redirect)
  if (args.next) params.set('next', args.next)
  return `/login/verify?${params.toString()}`
}
